import { render } from "./index.vue?vue&type=template&id=5e72c633&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5e72c633&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=5e72c633&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e72c633"]])

export default __exports__